function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "c"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#70efff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5770ff"
})), React.createElement("linearGradient", {
  id: "b"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0255fb"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#13ddf5"
})), React.createElement("linearGradient", {
  id: "a"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0081f8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#01ddff"
})), React.createElement("linearGradient", {
  xlinkHref: "#c",
  id: "d",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(.15 0 0 .15 .85 961.212)",
  x1: 305.201,
  y1: 598.592,
  x2: 305.785,
  y2: 8.244
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 602,
    height: 602,
    viewBox: "0 0 602 602",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    color: "#000"
  }, React.createElement("path", {
    style: {
      marker: "none"
    },
    d: "M21.653 961.362h48.694A20.607 20.607 0 0191 982.015v48.695a20.607 20.607 0 01-20.653 20.652H21.653A20.607 20.607 0 011 1030.71v-48.695a20.607 20.607 0 0120.653-20.653z",
    fill: "url(#d)",
    overflow: "visible",
    transform: "matrix(6.66667 0 0 6.66667 -5.667 -6408.081)"
  }), React.createElement("path", {
    d: "M132.458 171.625c-3.161 0-6.14.545-8.958 1.667l56.458 58.125 57.084 59.166 1.041 1.25 1.667 1.667 1.667 1.667 3.333 3.541 48.958 50.209c.815.506 3.178 2.694 5.023 3.617 2.377 1.188 4.954 2.283 7.61 2.378 2.866.103 5.796-.718 8.375-1.973 1.931-.94 2.79-2.286 5.034-4.022l56.667-58.542 57.291-58.958 55.209-56.875c-3.545-1.92-7.47-2.917-11.667-2.917zm-17.291 7.083c-6.021 5.705-9.792 14.281-9.792 23.959V393.5c0 7.836 2.517 14.954 6.667 20.417l7.916-7.5 58.959-57.292 52.291-50.625-1.041-1.25-57.292-58.958-57.292-59.167zm381.25 1.875l-55.834 57.709L383.5 297.25l-1.042 1.042L436.833 351l58.959 57.292 3.541 3.333c3.175-5.094 5-11.368 5-18.125V202.667c0-8.629-2.99-16.453-7.916-22.084zM237.875 305.375L185.792 356l-59.167 57.292-7.5 7.291c3.954 2.547 8.453 4.167 13.333 4.167H477.25c5.866 0 11.187-2.257 15.625-5.833l-3.75-3.75-59.167-57.292-54.375-52.5-48.958 50.417c-2.65 1.756-4.42 3.705-7.008 4.901-4.164 1.926-8.728 3.555-13.315 3.485-4.6-.071-9.11-1.871-13.237-3.902-2.072-1.019-3.176-2.032-5.607-4.068z",
    style: {
      marker: "none"
    },
    fill: "#fff",
    overflow: "visible"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.ac734fcf.svg";
export { ForwardRef as ReactComponent };